<template>
  <div class="wrap">
    <div class="img">
      <!-- <img :src="imgUrl" alt="" /> -->
      <AI :url="imgUrl" :fileId="fileId" />
    </div>

    <div class="box">
      <div class="title">
        <span class="bor"></span>
        当前农场作物：柑橘
      </div>

      <div class="grow">
        <!-- 圆圈 -->
        <div class="circle">
          <!-- 可信度 -->
          <div class="reliability" v-if="score">
            <div class="percentage">{{ score }}%</div>
            <div class="txt">可信度</div>
          </div>
          <!-- icon -->
          <div>
            <div :class="['icon', `icon${index}`]" v-for="(item, index) in icon" :key="item.label">
              <div class="icon_img">
                <img v-if="item.check" :src="item.img" alt="" />
                <img v-else :src="item.imgNomal" alt="" />
              </div>
              <div :class="['label', `label${index}`]">{{ item.label }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="box">
      <div class="title">
        <span class="bor"></span>
        识别结果（仅供参考）
      </div>

      <div class="result">
        <div class="re_box">
          <div class="item" v-for="item in growList" :key="item.key">
            <div>{{ item.label }}</div>
            <div>{{ item.value }}</div>
          </div>
        </div>

        <div class="re_box" style="display: none;">
          <div class="title">农事建议：</div>

          <!-- 管理要点 -->
          <div class="suggest">
            <div class="txt">
              <!-- -4 -->
              <div class="grph">
                <div class="tit">开花</div>
                <div>
                  彝乡冰糖橙果树花期从3月中旬开始，4月进入盛花期，油绿的叶片间，一簇簇橙花抱团开放，乳白色的花瓣，淡黄色的花蕊，带着微微橙子味的清香迎面袭来。
                </div>
                <div>
                  <img width="100% !important" height="100% !important" style="margin-top: 10px;" src="./../../../../static/images/openFlower.jpeg" alt="" />
                </div>
              </div>

              <!-- -1 -->
              <div class="grph">
                <div class="tit">梳花</div>
                <div>
                  冰糖橙花蕾的抽发量较大，为了有效提高坐果率，保证果子品质和口感，须对果树进行疏花。
                </div>
              </div>

              <!-- -2 -->
              <div class="grph">
                <div class="tit">1.自然落花</div>
                <div>
                  五山乡在橙子盛花期风势大，大风会使长势较弱的花自然脱落，进行第一步的优胜劣汰。
                </div>
                <div>
                  <img width="100% !important" height="100% !important" style="margin-top: 10px;" src="./../../../../static/images/openFlower2.jpeg" alt="" />
                </div>
              </div>
              <!-- -2-1 -->
              <div class="grph">
                <div class="tit">2.人工梳花</div>
                <div>
                  经过自然落花后，留下较为强健的花穗，再由人工将密集部分的花穗从基部轻轻摘除。在整个花期里，每一株成年果树，需疏除30%左右的花。
                </div>
              </div>

              <!-- -3 -->
              <div class="grph">
                <div class="tit">疏果</div>
                <div>
                  当花期渐渐过去时，果树上就会不断地结出幼果，果树进入结果期。如果结果量过多，会造成果树营养供应不足，影响果实的正常发育。所以需进行疏果。同疏花相似，疏果也需要经过自然落果和人工疏果两个阶段。人工疏果时，每根结果枝上选留1--2个幼果，其余的从果柄的基部将它们摘除。
                </div>
                <div>
                  <img width="100% !important" height="100% !important" style="margin-top: 10px;" src="./../../../../static/images/openFlower3.jpeg" alt="" />
                </div>
              </div>

              <!-- -4 -->
              <div class="grph">
                <div class="tit">果实发育期追肥</div>
                <div>
                  在果实的发育期，我们还要相应地追施有机肥以壮果。在此时期，果实的发育偏重于对氮与钾元素的需求，需在树冠投影处挖一条深度在10厘米以上的环形沟，将彝乡发酵的有机肥均匀的撒在沟里，以保证持续有效地为果子的生长及糖分的积累提供营养和能量。10月底，彝乡将迎来黄腾腾的丰收。
                </div>
                <div>
                  <img width="100% !important" height="100% !important" style="margin-top: 10px;" :src="
                      require('./../../../../static/images/openFlower4.jpeg')
                    " alt="" />
                </div>
              </div>

              <div class="tit">管理要点：</div>

              <!-- 1 -->
              <div class="grph">
                <div class="tit">清洁果园，杀灭病虫</div>
                <div>
                  采摘后恢复树势。一般橘园在采收后，不能马上进行修剪，应根据柑橘品种、树龄大小、栽培管理、气候条件、病虫发生等情况选用对口的药剂，在适宜的天气进行喷施，均匀喷透，防止剪口感染病菌，结合叶面肥迅速补充营养、恢复树势。
                </div>
                <div>
                  <img width="100% !important" height="100% !important" style="margin-top: 10px;" src="./../../../../static/images/640.webp" alt="" />
                </div>
              </div>

              <!-- 2 -->
              <div class="grph">
                <div class="tit">改土培土</div>
                <div>
                  秋冬培土，有抗旱保水，提高土壤通透性，促进根系生长，恢复树势的作用。同时，还有提高抗病虫能力、除虫、灭草和防寒等功效。培土需在秋冬至春季萌芽前进行，以干的火烧土、塘泥、河泥等沃土为主，培在树盘周围，厚度2~4厘米。
                </div>
              </div>
              <!-- 3 -->
              <div class="grph">
                <div class="tit">全园深翻</div>
                <div>
                  冬季深翻既可以通过断根促进柑橘树花芽分化、促发新根，也可以杀灭土壤中越冬的花蕾蛆、象甲、金龟子、大小实蝇等的部分幼虫和蛹。耕翻改变其越冬环境，或使其暴露与地表，易被鸟类啄食。每年冬季清园后，进行一次深翻，在树冠外围深翻20~30厘米，切断少量老根，促发新根，疏松熟化土壤。
                </div>
              </div>
              <!-- 4 -->
              <div class="grph">
                <div class="tit">保温防冻</div>
                <div>
                  霜冻前树干缠草，树盘培土，主干刷白，预防冻害及树脂病等病害发生。树干刷白的配置方法：用生石灰15-20公斤，食盐0.25公斤，石硫合剂渣液1公斤加水50公斤，进行配置。柑橘清园期用绿色伴侣650倍液与化学农药混配使用，可提高对螨类、
                  蚧类、蚜虫、木虱等病虫原的铲除作用哟。
                </div>
              </div>
            </div>
          </div>

          <!-- 施肥方案 -->
          <div class="suggest" v-if="imgInListStatus">
            <div class="txt">
              <div class="tit">施肥方案：</div>
              <div class="text">
                底肥用量建议挂果树每株施用有机肥5-10公斤、高氮高钾缓释型复合肥0.
                5-1.5公斤、摩力中微量元素肥0.25-0.5公斤、颗粒锌颗粒硼各20克左右。开深沟（长1-1.5米、宽30公分、深30-40公分）沟施，肥料放置沟旁土堆上混合后施入，建议1份肥3份土。（具体用量以当地农艺师建议为准。）
              </div>
            </div>
          </div>
          <div class="suggest">
            <div class="txt">
              <div class="tit">所需氮磷钾为：</div>
              <div class="item" v-for="item in fertilizerList" :key="item.key">
                <div>{{ item.label }}</div>
                <div>{{ item.value }}</div>
              </div>
            </div>
          </div>
          <!-- 病虫害防治 -->
          <div class="suggest">
            <div class="txt">
              <div class="tit">病虫害防治：</div>
              <div v-if="!imgInListStatus">
                <!-- 1 -->
                <div class="grph">
                  <div class="tit">溃疡病发生偏重的果园</div>
                  <div class="tit fs28">防治建议：</div>
                  <div>
                    先剪后喷，结合其他病虫防治，着重防治溃疡病。如果溃疡病病株率大于30%的果园，建议整园销毁，改种其他果树；病株率在30%以下的果园先剪除病枝、病叶、病斑多的大枝也应剪除，带出园外集中烧毁。
                  </div>
                  <div class="tit fs28">药剂选择：</div>
                  <div>
                    可用噻唑锌+代森锰锌或咪鲜胺+毒死蜱+叶面肥；单用波尔多液或石硫合剂，淋洗式均匀喷透，喷遍枝干和叶片，间隔20~30天再喷一次。
                  </div>
                </div>
                <!-- 2 -->
                <div class="grph">
                  <div class="tit">砂皮病、黄斑病发生偏重的果园</div>
                  <div class="tit">防治建议：</div>
                  <div>
                    对越冬能力强的病菌，第一次用药，选择对病菌效果明显的杀菌剂进行杀灭，减少病菌基数。
                  </div>
                  <div class="tit">药剂选择：</div>
                  <div>
                    可用苯醚甲环唑·丙环唑+代森锰锌+毒死蜱+乙螨唑+叶面肥；单用石硫合剂，淋洗式均匀喷透，喷遍枝干和叶片。先喷后剪，待修剪后再喷一次药剂，轮换使用。
                  </div>
                </div>
                <!-- 3 -->
                <div class="grph">
                  <div class="tit">青苔、煤烟病严重的果园</div>
                  <div class="tit fs28">防治建议：</div>
                  <div>
                    对青苔、煤烟病发生严重的果园，在柑橘树无果状态，宜添加对病菌铲除性、氧化性强的杀菌剂。
                  </div>
                  <div class="tit fs28">药剂选择：</div>
                  <div>
                    可用乙蒜素+菊酯类+炔螨特+叶面肥，淋洗式均匀喷透，喷遍枝干和叶片。先喷后剪，待修剪后再喷一次。
                  </div>
                </div>
                <!-- 4 -->
                <div class="grph">
                  <div class="tit">红蜘蛛、锈壁虱发生严重的果园</div>
                  <div class="tit fs28">防治建议：</div>
                  <div>
                    需要彻底消灭螨虫及卵块，减少越冬虫口基数，冬季低温，宜选择杀成虫兼杀卵、耐低温的杀螨剂。
                  </div>
                  <div class="tit fs28">药剂选择：</div>
                  <div>
                    可用炔螨特+毒死蜱+代森锰锌+叶面肥；或矿物油+毒死蜱+咪鲜胺+叶面肥，淋洗式均匀喷透，喷遍枝干和叶片。先喷后剪，待修剪后再喷一次。
                  </div>
                  <div>
                    <img width="100%" style="margin-top: 10px;" src="./../../../../static/images/641.webp" alt="" />
                  </div>
                </div>
              </div>
              <div v-else>
                红蜘蛛、锈壁虱、果实蝇、果蒂炭蛆病、疫霉褐腐病等。
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AI from '@/components/AI'

export default {
  components: { AI },
  data () {
    const icon = [
      {
        label: '春稍',
        check: false,
      },
      {
        label: '花开蕾果',
        check: false,
      },
      {
        label: '幼果期',
        check: false,
      },
      {
        label: '果实膨大期',
        check: false,
      },
      {
        label: '秋稍生长期',
        check: false,
      },
      {
        label: '转黄期',
        check: false,
      },
      {
        label: '采收期',
        check: false,
      },
      {
        label: '清园',
        check: false,
      },
    ]

    icon.map((item, index) => {
      item.img = require(`../../../../assets/images/grow${index}.png`)
      item.imgNomal = require(`../../../../assets/images/grow${index}_light.png`)
    })

    return {
      imgUrl: '',
      growList: [
        {
          label: '花果发育期',
          value: '果实转色阶段',
        },
        {
          label: '转黄期',
          value: `${new Date().getFullYear()}-12-05`,
        },
        {
          label: '谢花期',
          value: `${new Date().getFullYear() + 1}-02-11`,
        },
        {
          label: '预计采摘时间',
          value: `${new Date().getFullYear()}-12-10`,
        },
      ],

      growList2: [
        {
          label: '花果发育期',
          value: '果实成熟阶段',
        },
        {
          label: '转黄期',
          value: `${new Date().getFullYear()}-10-19`,
        },
        {
          label: '谢花期',
          value: `${new Date().getFullYear()}-03-30`,
        },
        {
          label: '预计采摘时间',
          value: `${new Date().getFullYear()}-11-20`,
        },
      ],

      fertilizerList: [
        {
          label: 'N（g/株）',
          value: '0.25~0.29',
        },
        {
          label: 'P202（g/株）',
          value: '0.37~0.75',
        },
        {
          label: 'K2N2（g/株）',
          value: '0.37~0.75',
        },
      ],

      fertilizerList2: [
        {
          label: 'N（g/株）',
          value: '0.25~0.29',
        },
        {
          label: 'P202（g/株）',
          value: '1.85~3.5',
        },
        {
          label: 'K2N2（g/株）',
          value: '1.88~2.22',
        },
      ],
      suggest: '除废芽。',
      icon,
      // 成熟期的图片
      imgs: [
        'https://api.ascod.cn/static-camera/20211209/20211209134121.jpg',
        'https://api.ascod.cn/static-camera/20211209/20211209134147.jpg',
        'https://api.ascod.cn/static-camera/20211209/20211209134130.jpg',
        'https://api.ascod.cn/static-camera/20211209/20211209134126.jpg',
        'https://api.ascod.cn/static-camera/20211209/20211209134137.jpg',
        'https://api.ascod.cn/static-camera/20211209/20211209134107.jpg',
        'https://api.ascod.cn/static-camera/20211209/20211209134142.jpg',
      ],
      imgInListStatus: false,

      fileId: '',
      score: null,
      results: [],
    }
  },

  created () {
    const { results, fileId, imgUrl } = this.$route.query
    this.fileId = fileId
    this.imgUrl = imgUrl
    this.results = results && JSON.parse(results)
  },

  mounted () {
    if (this.imgs.includes(this.imgUrl)) {
      this.imgInListStatus = true
      this.fertilizerList = [...this.fertilizerList2]
      this.growList = [...this.growList2]
    } else {
      this.imgInListStatus = false
    }

    this.citrusClassification()



  },

  methods: {
    // 生长周期
    async citrusClassification () {
      const results = [...this.results]
      const data = results.sort((a, b) => b - a)
      this.score = (data[0].score * 100).toFixed(4)

      console.log('this.score:', this.score)

      // 如果得到的识别可信度在60以下 则取当前日期枚举的时间所对应的生长周期
      // 1月15 - 1月25  春梢期
      // 1月26 - 3月11 开花期
      // 3月10 - 3月15 开花期
      // 3月16 - 5月10  夏梢
      // 5月11 - 9月17 膨大期
      // 9月18 - 10月30 转色
      // 10月31 - 12月5 成熟期
      // 12月6 - 1月14 清园

      const year = new Date().getFullYear()

      const time = [
        {
          sT: new Date(`${year}/01/15`).getTime(),
          eT: new Date(`${year}/01/25`).getTime(),
          label: '春梢期',
        },
        {
          sT: new Date(`${year}/01/26`).getTime(),
          eT: new Date(`${year}/03/01`).getTime(),
          label: '开花期',
        },
        {
          sT: new Date(`${year}/03/10`).getTime(),
          eT: new Date(`${year}/03/15`).getTime(),
          label: '开花期',
        },
        {
          sT: new Date(`${year}/03/16`).getTime(),
          eT: new Date(`${year}/05/10`).getTime(),
          label: '夏梢',
        },
        {
          sT: new Date(`${year}/05/11`).getTime(),
          eT: new Date(`${year}/09/17`).getTime(),
          label: '膨大期',
        },
        {
          sT: new Date(`${year}/09/18`).getTime(),
          eT: new Date(`${year}/10/30`).getTime(),
          label: '转色',
        },
        {
          sT: new Date(`${year}/10/31`).getTime(),
          eT: new Date(`${year}/12/05`).getTime(),
          label: '成熟期',
        },
        {
          sT: new Date(`${year}/12/06`).getTime(),
          eT: new Date(`${year + 1}/01/14`).getTime(),
          label: '清园',
        },
      ]

      if (this.score * 100 < 60) {
        const now = Date.now()
        const tar = time.find((o) => {
          if (o.sT <= now && now <= o.eT) {
            return o
          }
        })

        if (tar) {
          data[0].name = tar.label
        }
      }

      const labelEnum = {
        转色: '转黄期',
        成熟期: '采收期',
        膨大期: '果实膨大期',
        清园: '清园',
        秋稍: '秋稍生长期',
        开花期: '花开蕾果',
        春梢期: '春稍',
        夏梢: '幼果期',
      }

      this.icon.map((item) => {
        if (item.label === labelEnum[data[0].name]) {
          item.check = true

          this.growList[0].value = `果实${item.label}阶段`
        } else {
          item.check = false
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.wrap {
  padding: 15px;
  background: #f9f9fb;

  .img {
    width: 100%;
    margin-bottom: 24px;

    img {
      width: 100%;
      // border-radius: 16px;
    }
  }

  .grow {
    .circle {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 220px;
      height: 220px;
      border-radius: 50%;
      border: 5px solid #a9a9a9;
      margin: 80px auto;

      .icon {
        position: absolute;
        left: 0;
        top: 0;
        display: inline-block;
        text-align: center;

        .icon_img {
          width: 50px;
          height: 50px;

          img {
            width: 100%;
            height: 100%;
          }
        }

        .label {
          position: absolute;
          font-size: 14px;
          font-weight: bold;
        }
      }

      .icon0 {
        left: calc(50% - 25px);
        top: -25px;

        .label0 {
          left: 10px;
          top: -25px;
        }
      }

      .icon4 {
        left: calc(50% - 25px);
        top: unset;
        bottom: -25px;

        .label4 {
          left: -16px;
          bottom: -27px;
          width: 80px;
        }
      }

      .icon1 {
        left: unset;
        right: 7px;
        top: calc(8px);

        .label1 {
          bottom: 0px;
          right: -60px;
        }
      }

      .icon7 {
        left: 7px;
        top: 8px;

        .label7 {
          top: unset;
          bottom: 0px;
          left: -50px;
        }
      }

      .icon2 {
        top: calc(50% - 25px);
        right: -25px;
        left: unset;

        .label2 {
          bottom: -23px;
          right: -20px;
        }
      }

      .icon6 {
        left: -25px;
        top: calc(50% - 25px);

        .label6 {
          bottom: -25px;
          left: -50px;
        }
      }

      .icon3 {
        left: unset;
        right: 7px;
        top: unset;
        bottom: 0px;

        .label3 {
          right: -100%;
        }
      }

      .icon5 {
        top: unset;
        left: 7px;
        bottom: 0px;

        .label5 {
          left: -35px;
          bottom: -25px;
        }
      }
    }

    .reliability {
      .percentage {
        font-size: 15px;
        font-weight: bold;
        color: #4171e5;
        text-align: center;
      }
      .txt {
        font-size: 16px;
        font-weight: bold;
        color: #14284a;
        text-align: center;
      }
    }
  }
}

.box {
  width: 100%;

  .title {
    font-size: 18px;
    font-weight: bold;
    color: #14284a;
    margin-bottom: 15px;

    .bor {
      display: inline-block;
      width: 5px;
      height: 11px;
      background: #4171e5;
      margin-right: 10px;
    }
  }
}

.result {
  .re_box {
    background: #ffffff;
    box-shadow: 0px 5px 5px rgba(208, 199, 255, 0.06);
    border-radius: 5px;
    padding: 19px 15px 15px;
    margin-bottom: 15px;
  }

  .item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 45px;
    line-height: 45px;
    border-bottom: 1px solid #f1f1f1;
    font-size: 14px;

    &:last-child {
      border: none;
    }
  }

  .tit {
    font-size: 13px;
    line-height: 24px;
    color: #000000;
    font-size: 16px;
    font-weight: bold;
  }

  .txt {
    font-size: 14px;
    text-indent: 28px;
    margin-top: 4px;
  }

  .suggest {
    margin-top: 17px;

    .txt {
      width: auto;
      height: auto;
      background: #f7f7f7;
      border-radius: 5px;
      padding: 10px;
      margin-top: 9px;
      font-size: 14px;
      margin-bottom: 15px;
      text-indent: 0;

      .tit {
        font-weight: bold;
        color: #14284a;
      }
    }

    .text {
      line-height: 24px;
      text-indent: 28px;
    }
  }
}

.grph {
  margin: 10px 0 20px 0;

  .tit {
    margin-top: 10px;
  }

  img {
    width: 100% !important;
    height: 100% !important;
  }
}
</style>
